import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Paper,
  Pagination,
} from "@mui/material";
import sortIcon from "../../../assets/sort.png";
import useStyles from "./styles";

export interface TableHeading {
  label: string;
  sort?: string;
  align?: "left" | "center" | "right";
}

interface PaginationProps {
  totalPages: number;
  currentPage: number;
}

interface TableDesignProps {
  tableHeadings: TableHeading[];
  tableHeadColor?: string;
  filterHandler?: () => void;
  pagination?: PaginationProps | null;
  isLoader?: boolean;
  button?: JSX.Element | null;
  children: React.ReactNode;
  filterOption?: any;
  setFilterOption: (filterOption: any) => void;
  extraCSS?: any;
  extraClass?: any;
  cellColor?: any;
  fontWeight?: any;
  stickyHeader?: boolean; // allow controlling stickyHeader
}

const TableDesign: React.FC<TableDesignProps> = ({
  tableHeadings,
  tableHeadColor = "",
  filterHandler = () => {},
  pagination = null,
  button = null,
  filterOption = null,
  setFilterOption,
  children,
  extraCSS = {},
  extraClass = "",
  cellColor,
  fontWeight,
  stickyHeader = false, // default to true for stickyHeader
}) => {
  const classes = useStyles();
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFilterOption({
      ...filterOption,
      page: page,
    });
  };

  const paginationContainer = () => {
    if (!pagination) return null;

    return (
      <Pagination
        style={{ marginTop: "10px", float: "right", marginBottom: "10px" }}
        color="primary"
        variant="outlined"
        shape="rounded"
        count={pagination.totalPages}
        // page={pagination.currentPage}
        onChange={handlePageChange}
      />
    );
  };

  return (
    <>
      <Paper
        elevation={0}
        component="div"
        className={`mb-2 ${extraClass}`}
        sx={{
          overflowX: "scroll",
           ...(stickyHeader ? { maxHeight: "60vh" } : {}),
          // maxHeight: "60vh",
          ...extraCSS,
        }}
      >
        <Table size="small" stickyHeader={stickyHeader}>
          <TableHead
            style={{ background: tableHeadColor, marginBottom: "5px" }}
          >
            <TableRow>
              {tableHeadings.map((heading, i) => (
                <TableCell
                  sx={{
                    fontWeight: fontWeight ?? 600,
                    color:
                      i === 0 && heading?.label === "Service"
                        ? "#008E72"
                        : cellColor,
                   ...(stickyHeader
                      ? {
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          background: tableHeadColor || "#fff",
                        }
                      : {}),
                  }}
                  key={i}
                  className={classes.tableHeadCell}
                  align={heading.align ?? "center"}
                  onClick={(e) => {
                    if (heading.sort) {
                      setFilterOption({
                        ...filterOption,
                        orderBy: heading.sort,
                        orderIn:
                          filterOption.orderIn === "ASC" ? "DESC" : "ASC",
                      });
                      const parentElement = e.currentTarget.parentElement;
                      if (parentElement) {
                        Array.from(parentElement.childNodes).forEach(
                          (n: Node) => {
                            // Ensure it's an Element before using it
                            if (n instanceof Element) {
                              n.classList.remove("active");
                            }
                          }
                        );
                        e.currentTarget.classList.add("active");
                      }
                    }
                  }}
                >
                  <>
                    <span style={{ textTransform: "none" }}>
                      {heading.label === "ft3" ? (
                        <>
                          ft<sup>3</sup>
                        </>
                      ) : (
                        heading.label
                      )}
                    </span>
                    {heading.sort && (
                      <img
                        style={{ cursor: "pointer", height: "auto" }}
                        src={sortIcon}
                        alt="sort-icon"
                      />
                    )}
                  </>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </Paper>
      {pagination && paginationContainer()}
    </>
  );
};

export default TableDesign;
